import { handleError, hasError, tryCatch } from '@repo/shared/api/helpers'
import { AuthRoutes } from '@repo/shared/routes-auth'
import { CaseWorkersRoutes } from '@repo/shared/routes-case-workers'
import { OrganizationsRoutes } from '@repo/shared/routes-organizations'
import { AxiosInstance } from 'axios'

import {
  buildCaseWorkerFromDto,
  buildOrganizationFromDto,
  buildUserFromDto,
} from '@/external/api/helpers'
import { mockedData } from '@/store/mock/mock'
import { IApi } from '@/store/spi/api'

type T = {
  app: IApi['me']
}

export const apiMe: (api?: AxiosInstance) => T = (api): T => {
  return {
    //
    // APP
    //
    app: {
      getInitialValues: api
        ? async () => {
            const userRes = await tryCatch(
              async () =>
                await api.get<AuthRoutes.getCurrent.Response>(AuthRoutes.getCurrent.call()),
            )
            if (hasError(userRes)) return handleError(userRes)

            const organizationsRes = await tryCatch(
              async () =>
                await api.get<OrganizationsRoutes.get.Response>(OrganizationsRoutes.get.call()),
            )
            if (hasError(organizationsRes)) return handleError(organizationsRes)

            return {
              organizations: organizationsRes.organizations.map(buildOrganizationFromDto),
              user: buildUserFromDto(userRes.user),
            }
          }
        : () => {
            return Promise.resolve({
              organizations: mockedData.organizations,
              user: mockedData.user,
            })
          },

      patch: api
        ? async ({ organizationId, fields }) => {
            const res = await tryCatch(
              async () =>
                await api.patch<CaseWorkersRoutes.patchCurrent.Response>(
                  CaseWorkersRoutes.patchCurrent.call({ organizationId }),
                  { fields } satisfies CaseWorkersRoutes.patchCurrent.Request,
                ),
            )
            if (hasError(res)) return handleError(res)
            return buildCaseWorkerFromDto(res.caseWorker)
          }
        : (p) => {
            return Promise.resolve({
              ...mockedData.caseWorker,
              ...p.fields,
            })
          },

      patchPassword: api
        ? async ({ password }) => {
            const res = await tryCatch(
              async () =>
                await api.patch<AuthRoutes.patchPassword.Response>(
                  AuthRoutes.patchPassword.call(),
                  { password } satisfies AuthRoutes.patchPassword.Request,
                ),
            )
            if (hasError(res)) return handleError(res)
            return res
          }
        : () => {
            return Promise.resolve(true)
          },
    },
  }
}
